import { GetChatDashboardStatsPieResponse } from '@projects/shared/src/app/features/chat/interfaces/dashboard/GetChatDashboardStatsResponse';

export const highchartChatBreakdownConfig = (
  stats: GetChatDashboardStatsPieResponse,
  isLightTheme = false,
  colors: string[] = []
) => {
  const data: any = { ...stats };
  delete data.AvgChatPerDay;
  delete data.AvgResponseTime;
  delete data.TotalChats;

  if (colors.length === 0) colors = ['#FFFFFF', '#E4E7EC', '#98A2B3', '#667085'];
  if (isLightTheme && colors[0] == '#FFFFFF') {
    colors.shift();
    colors.unshift('#344054');
  }

  const config: Highcharts.Options = {
    colors,
    chart: {
      spacingLeft: 0,
      spacingRight: 0,
      spacingTop: 0,
      spacingBottom: 0,
      width: 190,
    },
    title: {
      text: undefined,
      verticalAlign: 'middle',
      y: 0,
      x: 0,
      style: {
        fontSize: '18px',
      },
    },
    tooltip: {
      formatter: function () {
        return [this.point.name.replace(/([A-Z])/g, ' $1') + ': ' + ((this.point as any).isZero ? 0 : this.y)];
      },
    },
    series: [
      {
        type: 'pie',
        name: 'Percentage',
        innerSize: '0%',
        data: Object.keys(data).map((key) => {
          const stats = data[key];
          const isZero = stats === 0;
          const y = isZero ? 0.1 : stats;

          return { name: key.replace(/([A-Z])/g, ' $1'), y, isZero };
        }),
      },
    ],
  };
  return config;
};
